import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Everybody should watch Children of Men",
  "description": "",
  "published": "2009-12-28T00:00:00.000Z",
  "redirect_from": ["/blog/everybody-should-watch-children-of-men/swizec/1031"],
  "categories": "England, Influenza pandemic, intrigues, Michael Caine, review, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Children of Men is a bloody brilliant movie that the above trailer doesn't quite do justice. It is quite simply the best dystopian/post-apocalyptic story my brain has ever had the pleasure of listening to.`}</p>
    <p>{`The story revolves around the idea of what would happen if the whole world turned to shit, humanity was doomed and only England of all places, remained standing against the onslaught of shite. The best part is that the whole sequence of events and what exactly is going on is never quite explained. We're told that the world started going fuckwards because of some sort of `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Influenza_pandemic",
        "title": "Influenza pandemic"
      }}>{`flu pandemic`}</a>{` in 2008 - note the movie was made in 2006 and we had a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Avian_influenza",
        "title": "Avian influenza"
      }}>{`bird flu`}</a>{` scare in 2008 - and then in 2009 all women went sterile ... this luckily hasn't happend IRL yet.`}</p>
    <p>{`Well the movie goes on 18 years after humans couldn't make babies anymore. Inexplicably there is a civil war setting up about the rights of immigrants and the whole `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Her_Majesty%27s_Government",
        "title": "Her Majesty's Government"
      }}>{`British government`}</a>{` is being very Orwellian in operation. Interestingly, they're becoming more and more Orwellian in real life as well.`}</p>
    <p>{`Children of Men, next to the the awesome story, also features`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      